import BaseModel from "~/models/BaseModel";

class TradeHistoryAnnualMonthlyAggregatesModel extends BaseModel {
}

export default TradeHistoryAnnualMonthlyAggregatesModel;
